import * as classnames from "classnames";

import {
  ApplicantChallengeLink,
  CliSupportBadge,
  ChallengeCountDownTimer,
  Icon,
  TagCloud,
  TagItem,
} from "..";
import ApplicantExamModel from "../../models/ApplicantExam.model";

/**
 * Enums
 */
import {
  ChallengeResultStatus,
  ProgrammingLanguage,
  ChallengeStyle,
} from "../../services/enums";

/**
 * Prop interface
 */
export interface ApplicantChallengeProps {
  challengeId: number;
  exam: ApplicantExamModel;
  tutorial?: boolean;
  className?: string;
}

/**
 * React Component
 */
export default function ApplicantChallenge({
  className,
  challengeId,
  exam,
  tutorial,
}: ApplicantChallengeProps) {
  const challenge = exam.getChallengeByChallengeId(challengeId);
  const challengeResult = exam.getResultByChallengeId(challengeId);

  const rootStyle = classnames("code-c-applicant-challenge", {
    "is-running": exam.isChallengeStarted(challenge.id),
    "is-finished": exam.isChallengeFinished(challenge.id),
    [`${className}`]: Boolean(className),
  });

  const programmingLanguages: TagItem[] = (
    challengeResult.programmingLanguage
      ? challenge.programmingLanguages.filter(
          (item) => item === challengeResult.programmingLanguage,
        )
      : challenge.programmingLanguages
  ).map((item) => ({
    label: ProgrammingLanguage.toString(item),
  }));

  return (
    <div className={rootStyle}>
      <div className="code-c-applicant-challenge__container">
        <div className="code-c-applicant-challenge__left">
          <div className="code-c-applicant-challenge__title">
            {challenge.title}
          </div>
          <div>
            <span className="code-c-applicant-challenge__subtitle">
              {challenge.getStyleLabel()}
            </span>
            {challenge.style === ChallengeStyle.Quiz && (
              <span className="code-c-applicant-challenge__subtitle">
                / {challenge.getQuestionCountLabel()}
              </span>
            )}
            {challenge.localExamEnabled && (
              <span className="code-c-applicant-challenge__subtitle">
                <CliSupportBadge />
              </span>
            )}
          </div>
          <div className="code-c-applicant-challenge__extend-info">
            <TagCloud tagItems={programmingLanguages} />
          </div>
        </div>
        <div className="code-c-applicant-challenge__right">
          <div>
            {!(
              exam.isChallengeStarted(challenge.id) ||
              exam.isChallengeFinished(challenge.id)
            ) ? (
              <strong>
                <Icon type={"clock-o"} />
                {challenge.getTimeLimitLabel()}
              </strong>
            ) : (
              <strong className="has-error">
                <ChallengeCountDownTimer challengeId={challenge.id} />
              </strong>
            )}
          </div>
          <div>
            {exam.isChallengeFinished(challenge.id) && (
              <div className="code-c-applicant-challenge__status">
                {ChallengeResultStatus.toString(challengeResult.status)}
              </div>
            )}
            <div>
              <ApplicantChallengeLink
                exam={exam}
                challengeId={challenge.id}
                tutorial={tutorial}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
